import { createFileRoute } from '@tanstack/react-router';
import { StandingOrdersPage } from '../components/pages/StandingOrdersPage/StandingOrdersPage';

export const Route = createFileRoute('/account/standing-orders')({
  component: StandingOrdersPage,
});
